<script>
import UAParser from 'ua-parser-js'
// import getSecret from '@utils/get-secret'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Input from '@components/form/InputValidation.vue'
import Select from '@components/form/Select.vue'
import Checkbox from '@components/form/CheckboxesInputValidation.vue'
import { habeasMethods } from '@state/helpers'

export default {
  page: {
    title: 'Tratamiento de Datos - Euro',
    meta: [
      {
        name: 'Formulario de Tratamiento de Datos',
        content: `Formulario de Tratamiento de Datos Euro Supermercados`,
      },
    ], // Used in a html meta tag,
  },
  components: { Input, Select, Checkbox },
  data() {
    return {
      submitting: false,
      habeas: null,
      form: {
        nombre: null,
        apellido_1: null,
        apellido_2: null,
        tipo_documento: null,
        documento: null,
        celular: null,
        email: null,
        canal: 'E-commerce',
        dispositivo: {
          marca: null,
          modelo: null,
        },
        habeas_data: 2,
      },
    }
  },
  watch: {
    habeas(newVal) {
      const ctx = this
      newVal = parseInt(newVal)
      this.form.habeas_data = newVal
      if (newVal === 1) {
        ctx.showModal()
      }
    },
  },
  computed: {
    getCompanyInfo: function() {
      return this.$store.state.appAuth.companyInfo || null
    },
  },
  mounted() {
    var uap = new UAParser()
    const uaString = window.navigator.userAgent
    uap.setUA(uaString)
    var result = uap.getResult()
    if (result.device.type) {
      this.form.dispositivo.marca = result.device.vendor || 'N/R'
      this.form.dispositivo.modelo = result.device.model || 'N/R'
    } else {
      this.form.dispositivo.marca = result.os.name || 'N/R'
      this.form.dispositivo.modelo = result.os.version || 'N/R'
    }
  },
  methods: {
    ...habeasMethods,

    async onSubmit() {
      let context = this
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        context.$generate_toast(
          context,
          'error',
          context.$t('fill_the_required_fields')
        )
        return
      }
      context.submit()
    },

    clearForm() {
      this.form = {
        nombre: null,
        apellido_1: null,
        apellido_2: null,
        tipo_documento: null,
        documento: null,
        celular: null,
        email: null,
        canal: 'E-commerce',
        dispositivo: {
          marca: null,
          modelo: null,
        },
        habeas_data: 2,
      }
    },

    submit() {
      let context = this
      context.submitting = true
      const promise = context.sendHabeasDataSurvey(context.form)
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            'información enviada correctamente'
          )
          setTimeout(() => {
            context.submitting = false
            context.clearForm()
            this.$nextTick(() => context.$refs.observer.reset())
          }, 4000)
        })
        .catch((error) => {
          context.submitting = false
          context.$axios_error_noty(error, context)
        })
    },
    showModal() {
      this.$refs['habeas_modal'].show()
    },
  },
}
</script>

<template>
  <div class="container">
    <b-row>
      <b-col md="12" class="text-center">
        <img
          v-if="getCompanyInfo && getCompanyInfo.light_logo"
          :src="
            getCompanyInfo.dark_logo ||
              require('@assets/images/logos/euro-logo.svg')
          "
          alt="euro-logo"
          height="80"
          style="max-width: 100%;"
          class="my-2"
        />
      </b-col>
      <b-col md="12" class="justify-content-center">
        <b-card
          class="col-lg-6 offset-lg-3 shadow-lg px-2 py-1 px-lg-3 py-lg-2"
          no-body
        >
          <h5 class="text-primary font-weight-bold">Registro</h5>
          <ValidationObserver ref="observer">
            <b-form slot-scope="{ validate }">
              <Input
                type="text"
                rules="required|alpha_spaces"
                label="Nombre"
                name="name"
                v-model="form.nombre"
                placeholder="Ingrese su nombre"
              >
                <template v-slot:prepend>
                  <b-input-group-text
                    ><i class="far fa-user-circle fe-3x"></i
                  ></b-input-group-text>
                </template>
              </Input>
              <Input
                type="text"
                rules="required|alpha_spaces"
                label="Primer Apellido"
                name="first_last_name"
                v-model="form.apellido_1"
                placeholder="Ingrese su primer apellido"
              >
                <template v-slot:prepend>
                  <b-input-group-text
                    ><i class="far fa-address-book fe-3x"></i
                  ></b-input-group-text>
                </template>
              </Input>
              <Input
                type="text"
                rules="alpha_spaces"
                label="Segundo Apellido"
                name="second_last_name"
                v-model="form.apellido_2"
                placeholder="Ingrese su segundo apellido"
              >
                <template v-slot:prepend>
                  <b-input-group-text
                    ><i class="far fa-user fe-3x"></i
                  ></b-input-group-text>
                </template>
              </Input>
              <Select
                rules="required"
                name="document_type"
                label="Tipo de Documento"
                :value="form.tipo_documento"
                :drfProvider="false"
                :opts="[
                  {
                    name: 'Cédula de Ciudadanía',
                    value: 'C',
                  },
                  {
                    name: 'Tarjeta de Identidad',
                    value: 'T',
                  },
                  {
                    name: 'Nit',
                    value: 'N',
                  },
                  {
                    name: 'Cédula de Extranjería',
                    value: 'E',
                  },
                  {
                    name: 'Otros',
                    value: 'O',
                  },
                ]"
                @input="(value) => (form.tipo_documento = value)"
              >
                <template v-slot:prepend>
                  <b-input-group-text class="rounded-0 rounded-left"
                    ><i class="far fa-user-circle fe-3x"></i
                  ></b-input-group-text>
                </template>
              </Select>
              <Input
                type="number"
                rules="required|min:6|max:11|numeric"
                label="Numero del Documento"
                name="document"
                v-model="form.documento"
                placeholder="Ingrese su numero de documento"
              >
                <template v-slot:prepend>
                  <b-input-group-text
                    ><i class="far fa-address-card fe-3x"></i
                  ></b-input-group-text>
                </template>
              </Input>
              <Input
                type="number"
                rules="required|length:10"
                label="Celular"
                name="cellphone"
                v-model="form.celular"
                placeholder="Ingrese su numero de celular"
              >
                <template v-slot:prepend>
                  <b-input-group-text
                    ><i class="fas fa-phone fe-3x"></i
                  ></b-input-group-text>
                </template>
              </Input>
              <Input
                type="email"
                rules="required|email"
                label="Correo"
                name="email"
                v-model="form.email"
                placeholder="Ingrese su correo electrónico"
              >
                <template v-slot:prepend>
                  <b-input-group-text
                    ><i class="far fa-envelope fe-3x"></i
                  ></b-input-group-text>
                </template>
              </Input>
            </b-form>
          </ValidationObserver>
          <h5 class="text-primary font-weight-bold"
            >Tratamiento de datos personales</h5
          >

          <b-form-checkbox
            id="habeas_date"
            v-model="habeas"
            name="habeas_date"
            value="1"
            unchecked-value="2"
          >
            Para continuar marca esta casilla para leer la autorización para el
            tratamiento de tus datos personales.
          </b-form-checkbox>
          <b-row class="justify-content-center mt-2 p-2">
            <b-button
              variant="primary rounded"
              :class="{ disabled: submitting }"
              @click="onSubmit"
              class="w-100"
            >
              <span v-if="submitting"
                ><b-spinner variant="white" small></b-spinner> Enviado...</span
              >
              <span v-else>Enviar Información</span>
            </b-button>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <!-- <b-button v-b-modal.modal-1>Launch demo modal</b-button> -->

    <b-modal ref="habeas_modal" size="lg" body-class="p-4" :hide-header="true">
      <!-- <p class="my-4">Hello from modal!</p> -->
      <sweetalert-icon icon="info" color="#FFDD00" />
      <h5 class="text-primary font-weight-bold text-center mb-3"
        >Autorización para el Tratamiento de datos personales</h5
      >
      <p class="text-justify">
        Con el diligenciamiento de mis datos personales manifiesto que autorizo
        de manera previa, expresa e informada a Inversiones Euro S.A, de acuerdo
        con lo dispuesto en los respectivos ordenamientos jurídicos aplicables,
        para recolectar, almacenar, usar, circular y suprimir mis datos para los
        fines expuestos a continuación:
      </p>
      <ul>
        <li
          >Invitarme a eventos y ofrecer nuevos productos, servicios y
          lanzamientos exclusivos.</li
        >
        <li
          >Contactarme a través de medios electrónicos – SMS o chat para el
          envío de noticias relacionadas con campañas de fidelización o mejora
          de servicio.</li
        >
        <li
          >Cumplir las obligaciones resultantes de las relaciones comerciales
          que llegue a establecer conmigo; informarme sobre condiciones
          comerciales, otorgarme garantía sobre productos adquiridos.</li
        >
        <li
          >Realizar análisis estadístico de mis datos para prospección
          comercial, inteligencia de negocio, mercadeo relacional para
          mejoramiento de la oferta comercial y servicio al cliente.</li
        >
        <li
          >Circular mis datos de forma segura con encargados de alguno de los
          tratamientos aquí expuestos.</li
        >
        <li
          >Consultarme en base de datos públicas para la gestión de riesgo de
          lavado de activos, financiación de terrorismo, soborno y
          corrupción.</li
        >
      </ul>
      <p class=""
        >Puedo ejercer mi derecho de habeas data ingresando a
        www.eurosupermercados.com.co o a través del correo electrónico
        <a href="mailto:protecciondedatos@eurosupermercados.com"
          >protecciondedatos@eurosupermercados.com</a
        >.</p
      >
      <template #modal-footer="{ ok, cancel }">
        <b-row class="w-100 justify-content-center">
          <b-button
            variant="outline-primary rounded mr-2"
            style="min-width: 100px"
            @click="
              () => {
                cancel()
                habeas = 2
              }
            "
          >
            Rechazar
          </b-button>
          <b-button
            variant="primary rounded"
            style="min-width: 100px"
            @click="ok()"
          >
            Aceptar
          </b-button>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<style lang="scss" module>
body {
  background-color: rgb(226, 226, 226);
  padding-bottom: 0px;
}
ul {
  padding-inline-start: 18px;
}
</style>
